import { Platform, Prices, SelectedTalent, Talent } from "../shared/types";
import { orderedTalentIds } from "./orderedTalentIds";


export function buildListSheetValues(params: {
    platforms: Platform[];
    talent: Talent[];
    selectedTalent: SelectedTalent;
    talentOrder?: string[];
}): string[][] {
    const { platforms, talent, selectedTalent, talentOrder } = params;
    const exportOrder = orderedTalentIds(selectedTalent, talentOrder);
    const platform = platforms[0];
    const rows: string[][] = [];

    const selectedPlatforms: Platform[] = ["TikTok", "Instagram", "YouTube"];

    // rows.push(["List name", listName]);
    // rows.push(["Platform", platform || ""]);
    // rows.push(["Campaign type", filter.campaignType || ""]);
    // rows.push(["Currency", filter.currency || ""]);
    // rows.push([]);

    for (const [idx, talId] of exportOrder.entries()) {
        const tal = talent.find((t) => t.id === talId);

        const talentData = {
            "Username": getUsernameForListExport(tal, platform),
            "Country": tal?.country || "",
            "Cities": tal?.cities?.join(", ") || "",
            ...getPlatformLinks(tal, selectedPlatforms), // LINKS
            "Custom Price": (selectedTalent[talId]?.price || 0).toString(),
            ...getPlatformPrices(tal, selectedPlatforms),
            "Manager Emails": tal?.managers?.map((manager) => manager.email).join(", ") || "",
            ...getPlatformAudienceData(tal, selectedPlatforms), // AUDIENCE DATA
            "Content Tags": tal?.contentTags?.join(", ") || "",
            "Notes": selectedTalent[talId]?.notes || "",
        }

        if (idx === 0) {
            rows.push(Object.keys(talentData));
        }

        rows.push(Object.values(talentData));
    }

    // console.table(rows);

    return rows;
}

////////////////////////////////////////////////////////////
// Platform Audience Data
////////////////////////////////////////////////////////////
function getPlatformAudienceData(tal: Talent | undefined, selectedPlatforms: Platform[]) {
    const audienceData: Record<string, string> = {};
    for (const platform of selectedPlatforms) {

        const platformData = tal?.platformData?.[platform];

        audienceData[`${platform} Followers`] = platformData?.followers?.toString() || "";
        audienceData[`${platform} Female Follower Percentage`] = platformData?.femaleFollowerPct?.toString() || "";
        audienceData[`${platform} Male Follower Percentage`] = platformData?.maleFollowerPct?.toString() || "";
        audienceData[`${platform} Top Follower Location`] = platformData?.topFollowerLocation?.toString() || "";
        audienceData[`${platform} Top Follower Location Percentage`] = platformData?.topFollowerLocationPct?.toString() || "";
        audienceData[`${platform} Top Follower Age Bracket`] = platformData?.topFollowerAgeBracket?.toString() || "";
        audienceData[`${platform} Top Follower Age Bracket Percentage`] = platformData?.topFollowerAgeBracketPct?.toString() || "";
    }
    return audienceData;
}

////////////////////////////////////////////////////////////
// Prices
////////////////////////////////////////////////////////////
// function formatListExportPrice(
//     talId: string,
//     // tal: Talent | undefined,
//     // useCustomPrices: boolean,
//     selectedTalent: SelectedTalent,
//     filter: BrowseFilter,
// ): string {
//     const sym = getCurrencySymbol(filter.currency);
//     // if (useCustomPrices && selectedTalent[talId]?.price != null) {
//     return `${sym}${selectedTalent[talId].price}`;
//     // }
//     // if (filter.campaignType === "Song" && tal?.defaultPrice != null) {
//     //     return `${sym}${tal.defaultPrice} (default)`;
//     // }
//     // return "";
// }

// Record ensures all keys from the Prices interface to be included in the PRICES_MAP
const PRICES_MAP: Record<keyof Prices, string> = {
    "brandPriceInstagramPost": "Instagram Post Price",
    "brandPriceInstagramReel": "Instagram Reel Price",
    "brandPriceInstagramStory": "Instagram Story Price",
    "brandPriceTikTok": "TikTok Brand Price",
    "brandPriceYouTubeIntegration": "YouTube Integration Price",
    "brandPriceYouTubePreroll": "YouTube Preroll Price",
    "brandPriceYouTubeShort": "YouTube Short Price",
    "brandPriceYouTubeVideo": "YouTube Video Price",
    "songPriceInstagram": "Instagram Song Price",
    "songPriceTikTok": "TikTok Song Price",
    "songPriceYouTube": "YouTube Song Price",
};

function getPlatformPriceKeys(platform: Platform) {
    return Object.keys(PRICES_MAP).filter((key) => key.includes(platform)) as (keyof Prices)[];
}

function getPlatformPrices(tal: Talent | undefined, selectedPlatforms: Platform[]) {
    const prices: Record<string, string> = {};
    for (const platform of selectedPlatforms) {
        const platformPriceKeys = getPlatformPriceKeys(platform);
        for (const key of platformPriceKeys) {
            prices[`${PRICES_MAP[key]}`] = tal?.localPrices?.[key]?.toString() || "";
        }
    }
    return prices;
}

////////////////////////////////////////////////////////////
// Misc
////////////////////////////////////////////////////////////
function getUsernameForListExport(tal: Talent | undefined, platform: Platform | undefined): string {
    if (!tal || !platform) {
        return "";
    }
    return tal.platformData?.[platform]?.username || "";
}

function getPlatformLinks(tal: Talent | undefined, selectedPlatforms: Platform[]) {
    const links: Record<string, string> = {};
    for (const platform of selectedPlatforms) {
        const username = tal?.platformData?.[platform]?.username || "";

        if (platform === "TikTok") {
            links["TikTok Profile URL"] = username ? `https://tiktok.com/@${username}` : "";
        }
        if (platform === "Instagram") {
            links["Instagram Profile URL"] = username ? `https://instagram.com/${username}` : "";
        }
        if (platform === "YouTube") {
            links["YouTube Profile URL"] = username ? `https://www.youtube.com/@${username}` : "";
        }
    }
    return links;
}





// export function buildListSheetValuesOriginal(params: {
//     listName: string;
//     filter: BrowseFilter;
//     talent: Talent[];
//     selectedTalent: SelectedTalent;
//     useCustomPrices: boolean;
//     notesBookerViewable: boolean;
// }): string[][] {
//     const { filter, talent, selectedTalent, useCustomPrices, notesBookerViewable } = params; // listName
//     const platform = filter.campaignPlatform;
//     const rows: string[][] = [];

//     const selectedPlatforms: Platform[] = ["TikTok", "Instagram", "YouTube"];

//     // rows.push(["List name", listName]);
//     // rows.push(["Platform", platform || ""]);
//     // rows.push(["Campaign type", filter.campaignType || ""]);
//     // rows.push(["Currency", filter.currency || ""]);
//     // rows.push([]);

//     const headerRow = [
//         "Username", // Main (Platform) Username
//         "Country",
//         "Cities",
//         ...selectedPlatforms.map((platform) => `${platform} Profile URL`), // TT, IG and YT Links
//         "Custom Price",
//         ...getPlatformPriceHeaders("TikTok"), // SEE NOTES
//         "Manager Emails",// Manager Emails
//         ...selectedPlatforms.map((platform) => getAudienceDataHeadersForListExport(platform)).flat(),// Location and Gender Demographics for Selected Platforms +         // Followers for relevant platforms, if available
//         "Content Tags",
//         notesBookerViewable ? "Notes (booker viewable)" : "Notes (internal)", // Notes
//     ];
//     rows.push(headerRow);

//     for (const talId of Object.keys(selectedTalent)) {
//         const tal = talent.find((t) => t.id === talId);

//         const dataRow = [
//             getUsernameForListExport(tal, platform), // Username
//             tal?.country || "", // Country
//             tal?.cities?.join(", ") || "", // Cities
//             ...selectedPlatforms.map((platform: Platform) => getProfileUrlForListExport(tal, platform)), // TT, IG and YT Links
//             formatListExportPrice(talId, selectedTalent, filter), // Custom Price
//             ...getPlatformPriceValues(tal, "TikTok"),
//             tal?.managers?.map((manager) => manager.email).join(", ") || "", // Manager Emails
//             ...selectedPlatforms.map((platform) => getAudienceDataForListExport(tal, platform)).flat(), // Location and Gender Demographics for Selected Platforms +             // Followers for relevant platforms, if available
//             tal?.contentTags?.join(", ") || "", // Content Tags
//             selectedTalent[talId]?.notes || "", // Notes
//         ];
//         rows.push(dataRow);
//     }

//     console.table(rows);

//     return rows;
// }


// function getAudienceDataHeadersForListExport(platform: Platform) {
//     return [
//         `${platform} Followers`,
//         `${platform} Female Follower Percentage`,
//         `${platform} Male Follower Percentage`,
//         `${platform} Top Follower Location`,
//         `${platform} Top Follower Location Percentage`,
//         `${platform} Top Follower Age Bracket`,
//         `${platform} Top Follower Age Bracket Percentage`,
//     ];
// }

// function getAudienceDataForListExport(tal: Talent | undefined, platform: Platform): string[] {
//     const platformData = tal?.platformData?.[platform];

//     return [
//         platformData?.followers?.toString() || "",
//         platformData?.femaleFollowerPct?.toString() || "",
//         platformData?.maleFollowerPct?.toString() || "",
//         platformData?.topFollowerLocation?.toString() || "",
//         platformData?.topFollowerLocationPct?.toString() || "",
//         platformData?.topFollowerAgeBracket?.toString() || "",
//         platformData?.topFollowerAgeBracketPct?.toString() || "",
//     ];
// }


// function getProfileUrlForListExport(tal: Talent | undefined, platform: Platform | undefined): string {
//     if (!tal || !platform) {
//         return "";
//     }

//     const username = tal.platformData?.[platform]?.username || "";

//     if (platform === "TikTok" && tal.platformData?.TikTok?.username) {
//         return `https://tiktok.com/@${username.toLowerCase()}`;
//     }
//     if (platform === "Instagram" && tal.platformData?.Instagram?.username) {
//         return `https://instagram.com/${username}`;
//     }
//     if (platform === "YouTube" && tal.platformData?.YouTube?.username) {
//         return `https://www.youtube.com/@${username}`;
//     }
//     return "";
// }

// function getPlatformPriceHeaders(platform: Platform): string[] {
//     const priceKeys = getPlatformPriceKeys(platform);
//     return priceKeys.map((key) => PRICES_MAP[key]);
// }

// function getPlatformPriceValues(tal: Talent | undefined, platform: Platform): string[] {
//     const priceKeys = getPlatformPriceKeys(platform);
//     return priceKeys.map((key) => tal?.localPrices?.[key]?.toString() || ""); // TODO: currency symbol
// }